module.exports = __webpack_public_path__ + "32048258691ebc81f003f06a8f647b2f.svg";